import * as React from "react";
import {  action, computed, observable } from "mobx";
import { inject, observer } from "mobx-react";
import { FormControl, InputGroup } from "react-bootstrap";
import { ISymbolStore, ISymbolNameDetails } from "../../stores/symbolStore";
import "./SymbolSelect.scss";

interface AppProps {
    symbolStore?: ISymbolStore;
    symbolSelect?: ISymbolSelect;
    excludedSymbols?: string[];
}

interface ISymbolSelect {
    symbols: string[];
}

interface ISymbolOption {
    text: string;
    value: string;
    checked: boolean;
    visible: boolean;
}

interface IGroupOption {
    value: string;
    total: number;
    checked: number;
    visible: boolean;
}

@inject( "symbolStore")
@observer
export default class SymbolSelect extends React.Component<AppProps> {
  
    @observable expandedGroups: Map<string, boolean> = new Map<string, boolean>();
    @observable searchCriteria: string = '';

    @computed get symbolNameDetailsFiltered(): ISymbolNameDetails[]{
        return this.props.symbolStore.symbolNameDetails.filter(snd => !this.props.excludedSymbols.includes(snd.symbol));
    }       

    @computed get groups(): IGroupOption[] {
        var distinctGroups =  [...new Set(this.symbolNameDetailsFiltered.map(snd => snd.quoteLong))].sort();
        return distinctGroups.map(g => {
            var groupSymbolNameDetails = this.symbolNameDetailsFiltered.filter(snd => snd.quoteLong == g);
            var groupSymbols = groupSymbolNameDetails.map(snd => snd.symbol);

            return {
                value: g,
                total: groupSymbols.length,
                checked: this.props.symbolSelect.symbols.filter(s => groupSymbols.includes(s)).length,
                visible: !this.searchCriteria || groupSymbolNameDetails.filter(snd => snd.pair.toLowerCase().includes(this.searchCriteria.toLowerCase())).length > 0
            };
        });
    }

    getSymbols(group: string): ISymbolOption[] {
       return this.symbolNameDetailsFiltered
        .filter(snd => snd.quoteLong == group)
        .sort((a, b) => a.pair.localeCompare(b.pair))
        .map(snd => {
            return {
                text: snd.pair,
                value: snd.symbol,
                checked: this.props.symbolSelect.symbols.includes(snd.symbol),
                visible: !this.searchCriteria || snd.pair.toLowerCase().includes(this.searchCriteria.toLowerCase())
            };
        });        
    }

    @action.bound search(e: any): void {
        this.searchCriteria = e.target.value;
    }

    changeGroup(group: string, checked: boolean): void {
        var availableSymbols = this.symbolNameDetailsFiltered
            .filter(snd => snd.quoteLong == group)
            .map(snd => snd.symbol);
        
        var filterSymbols = this.props.symbolSelect.symbols;

        if (checked) {
            var missingSymbols = availableSymbols.filter(s => !filterSymbols.includes(s));
            this.props.symbolSelect.symbols.push(...missingSymbols);            
        } else {
            this.props.symbolSelect.symbols = this.props.symbolSelect.symbols.filter(s => !availableSymbols.includes(s));
        }
    }

    changeSymbol(symbol: string, checked: boolean): void {
        if (checked) {
            this.props.symbolSelect.symbols.push(symbol);            
        } else {
            this.props.symbolSelect.symbols = this.props.symbolSelect.symbols.filter(s => s != symbol);
        }
    }   
   

    toggleExpanded(group: IGroupOption): void {
        var newValue = this.expandedGroups.has(group.value) ? !this.expandedGroups.get(group.value) : true;
        this.expandedGroups.set(group.value, newValue);
    }

    render() {
        return (
            <div className="symbol-select" >
                <InputGroup className="mb-3 symbol-select-search">   
                        {/* <InputGroup.Prepend>
                            <InputGroup.Text>
                                <i className="fas fa-search"></i>
                            </InputGroup.Text>
                        </InputGroup.Prepend>                 */}
                        <FormControl aria-label="Change" type="text" placeholder="Search..." value={this.searchCriteria} onChange={this.search} />
                        <InputGroup.Append>
                            <InputGroup.Text>
                                <i className="fas fa-times" onClick={() => this.searchCriteria = ''}></i>
                            </InputGroup.Text>
                        </InputGroup.Append>
                    </InputGroup>
                <div className="symbol-select-menu">
                    
                    {
                        this.groups.map(g => {
                            return (
                                <div key={g.value} className={g.visible ? 'symbol-select-group' : 'hidden'}>
                                    <i className={this.expandedGroups.get(g.value) ? 'fas fa-chevron-down': 'fas fa-chevron-right'} 
                                       onClick={() => this.toggleExpanded(g)}></i>
                                    <input type="checkbox" checked={g.checked == g.total} onChange={() => this.changeGroup(g.value, !(g.checked == g.total))}/>
                                    <span><b>{g.value} ({g.checked}/{g.total})</b></span>
                                    {
                                        (this.expandedGroups.get(g.value) || this.searchCriteria) && this.getSymbols(g.value).map(s => {
                                            return (
                                                <div key={s.value} className={s.visible ? 'symbol-select-symbol' : 'hidden'}>
                                                    <input type="checkbox" checked={s.checked} onChange={() => this.changeSymbol(s.value, !s.checked)} />
                                                    <span>{s.text}</span>
                                                </div>                           
                                            )
                                        })
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        );
    }
}